import React from "react";
import { Form, Slider } from "antd";
import i18n from "i18next";
import ColorPicker from "../../tools/common/ColorPicker";
import { ICONS } from "../../../constants/Icons";

const IconDefaultPropertiesPanel = ({
    svgIcon,
    svgIconHandler,
    svgFill,
    svgFillHandler,
    svgScale,
    svgScaleHandler,
}) => {
    return (
        <>
            <h3>{i18n.t("propertyBar.shapes.title")}</h3>

            <div className="rde-icons-container">
                {ICONS.map((icon) => {
                    const isActive = svgIcon?.id === icon.id;

                    return (
                        <button
                            key={icon.id}
                            type="button"
                            className={`rde-icons-container-btn ${isActive ? "active" : ""}`}
                            onClick={() => svgIconHandler(icon)}
                            dangerouslySetInnerHTML={{ __html: icon.svg }}
                        />
                    );
                })}
            </div>

            <Form.Item
                label={i18n.t("propertyBar.icon.fontIcon")}
                labelCol={{ span: 12 }}
                wrapperCol={{ span: 12 }}
            >
                <Slider
                    min={0.1}
                    step={0.1}
                    max={2}
                    value={svgScale}
                    onChange={svgScaleHandler}
                />
            </Form.Item>

            <Form.Item
                label={i18n.t("propertyBar.shapes.fillColor")}
                labelCol={{ span: 12 }}
                wrapperCol={{ span: 12 }}
            >
                <ColorPicker value={svgFill} onChange={svgFillHandler} />
            </Form.Item>
        </>
    );
};

export { IconDefaultPropertiesPanel };